import "./PageGameList.scoped.scss";
import { ReactComponent as IconGameBlue } from "assets/images/icon-game-blue.svg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useState } from "react";

let dummyData = [
  // {
  //   gamename: "o2",
  //   image:
  //     "//file.valofe.com/Valofe_file/web/vfun/images/game/enroll/o2jamonline-icon-min.png",
  //   icon: "desktop",
  // },
  // {
  //   gamename: "black",
  //   image:
  //     "//file.valofe.com/Valofe_file/web/vfun/images/game/enroll/blacksquadr2-icon-min.png",
  //   icon: "desktop",
  // },
];

function PageGameList() {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useState(false);
  const gameListToggleClick = () => {
    setIsHidden((prev) => !prev);
  };

  return (
    // 게임 리스트 데이터가 없을 경우 아예 안보이게 처리
    dummyData.length === 0 ? null : (
      <nav className="com-game-nav">
        <h3 className="nav-tit">
          <IconGameBlue /> <span>{t("GameNavTit")}</span>
        </h3>

        {!isHidden ? null : (
          <div>
            <ul className="default-list">
              {/* {dummyData.map((i) => (
                <li className="lnb-game">
                  <Link to={`#`} className="each-game">
                    <img className="icon-game" src={i.image} alt={i.gamename} />
                    {i.gamename}
                    <i className={`fa fa-${i.icon}`} />
                  </Link>
                </li>
              ))} */}
            </ul>
          </div>
        )}

        <div className="more-games">
          <Link to="#" className="btn-game-more" onClick={gameListToggleClick}>
            <i className={`fa fa-angle-double-${isHidden ? "up" : "down"}`} />
            {!isHidden ? t("See_more_Community") : t("Fold_the_community")}
          </Link>
        </div>
      </nav>
    )
  );
}

export default PageGameList;
